import { YEARS_IN_BUSINESS } from '../constants/companyInfo';

// Maps {{VAR_NAME}} tokens found in Contentful rich text to their values.
// We can update this with any other variables we need to replace.
const contentfulVariables: Record<string, string | number> = {
  YEARS_IN_BUSINESS,
};

//Find text in {{TEXT}} format and get the text between.
const variableRegExp = /\{\{(\w+)\}\}/g;

/**
 * Replaces any {{VAR_NAME}} tokens in plain text with their corresponding value.
 * @param value any[] | string - Passed by renderNode
 * @returns
 */
export const replaceContentfulVariables = (value: string[] | unknown[]) => {
  return value?.map((item) => {
    // If type is string, replace the variables
    if (typeof item === 'string') {
      return item.replace(variableRegExp, (match, variableName) =>
        variableName in contentfulVariables
          ? String(contentfulVariables[variableName])
          : match,
      );
    }

    return item;
  });
};
